import { type FC } from 'react';

import { type LotterySeasonHistoryData } from '@/common/types/lottery';
import { Picture } from '@/components/ui/Picture/Picture';

import { prizeIcon } from '../prizes';

type SeasonPrizePoolProps = Pick<
  LotterySeasonHistoryData,
  'prizePool' | 'totalPrizePool'
>;

/**
 * What a drawn season paid out: T-Gem / dice with their icons, or the USD of
 * the seasons before the switch to in-game prizes.
 */
const SeasonPrizePool: FC<SeasonPrizePoolProps> = ({
  prizePool,
  totalPrizePool,
}) => {
  // Older backend without the per-prize summary: USDT only
  const pool = prizePool ?? { usdt: totalPrizePool };
  const items = (['tgem', 'dice'] as const).filter((name) => pool[name]);

  if (!items.length) {
    // Money only in the seasons drawn before; nothing won at all — a dash
    return <>{pool.usdt ? `${pool.usdt} $` : '—'}</>;
  }

  return (
    <span className="inline-flex items-center gap-2">
      {items.map((name) => {
        const icon = prizeIcon(name);

        return (
          <span key={name} className="inline-flex items-center gap-1">
            {pool[name]?.toLocaleString('ru-RU')}
            <Picture
              img={icon.png}
              webp={icon.webp}
              alt={name}
              className="block size-4 shrink-0"
            />
          </span>
        );
      })}
    </span>
  );
};

export { SeasonPrizePool };
